@if (currentUser()) {
    <div
        class="mad-navigation-bar"
        [class.mad-navigation-bar--compact]="isCompact()"
    >
        <div class="mad-navigation-bar__body">
            @let isNavigationGuardOrResolverInProgress = isNavigationGuardOrResolverInProgress$ | async;
            <div class="mad-navigation-bar__logo-wrapper">
                <a
                    class="mad-navgation-bar__logo"
                    [routerLink]="homeNavItem.routeSubItems | translateRoute: homeNavItem.routeSubItemParams"
                    [routerLinkActive]="'pointer-events--none'"
                    [routerLinkActiveOptions]="homeNavItem.routerLinkActiveOptions"
                >
                    <sfx-logo [path]="isCompact() ? 'sfx.svg#sfx' : 'swissfex.svg#swissfex'"></sfx-logo>
                </a>
            </div>
            <app-sidebar-item
                [item]="homeNavItem"
                [isCollapsed]="isCompact()"
                class="mad-navigation-bar__home"
            ></app-sidebar-item>

            @if (projectSpecificNavItems()?.length) {
                <sfx-section-separator extraClasses="mad-margin-horizontal-n8"></sfx-section-separator>
                <div class="mad-navigation-bar__group">
                    @for (navItem of projectSpecificNavItems(); track navItem.id) {
                        <app-sidebar-item
                            [item]="navItem"
                            [isCollapsed]="isCompact()"
                            [isNavigationResolverInProgress]="isNavigationGuardOrResolverInProgress"
                        ></app-sidebar-item>
                    }
                </div>
                <sfx-section-separator extraClasses="mad-margin-horizontal-n8"></sfx-section-separator>
            }
            <div class="mad-spacer"></div>
            <sfx-section-separator extraClasses="mad-margin-horizontal-n8"></sfx-section-separator>
            @for (navItem of bottomNavItems(); track navItem.id) {
                <app-sidebar-item
                    [item]="navItem"
                    [isCollapsed]="isCompact()"
                    [isNavigationResolverInProgress]="isNavigationGuardOrResolverInProgress"
                ></app-sidebar-item>
            }
            <sfx-section-separator extraClasses="mad-margin-horizontal-n8"></sfx-section-separator>
            <app-sidebar-item
                [item]="presenterViewNavItem()"
                [isCollapsed]="isCompact()"
                [isNavigationResolverInProgress]="isNavigationGuardOrResolverInProgress"
            ></app-sidebar-item>
        </div>
    </div>
}
